export default function () {
    return {
        restrict: 'E',
        scope: {
            toolName: '=',
            onPurchaseClick: '=onPurchaseClick',
            purchaseDataOne: '@',
            purchaseDataTwo: '@',
        },
        template: `<div class="mdc-dialog" id="alert_dialog">
            <div class="mdc-dialog__container">
                <div class="mdc-dialog__surface" role="alertdialog" aria-modal="true" aria-labelledby="my-dialog-title"
                    aria-describedby="my-dialog-content">
                    <div class="mdc-dialog__content" id="my-dialog-content">
                        This is a preview of the {{ toolName }}. Please upgrade your subscription to get
                        full
                        access to
                        the
                        tool.
                        (School and district wide plans are also available. Contact <a
                            href="mailto:sales@drawpforschool.com" target="_blank">
                            sales@drawpforschool.com</a> for more information.)
                    </div>
                    <div class="mdc-dialog__actions">
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="accept"
                            ng-click="onPurchaseClick(purchaseDataOne, purchaseDataTwo)">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label">Upgrade</span>
                        </button>
                        <button type="button" class="mdc-button mdc-dialog__button" data-mdc-dialog-action="cancel">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label">Cancel</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mdc-dialog__scrim"></div>
        </div>`
    };
};